<!-- eslint-disable default-case -->
<script lang="ts">
/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable max-len */
export default {
  name: 'UIButtonPrimary',
}
</script>

<script setup lang="ts">
import { ButtonType } from './';

export interface Props {
  type?: ButtonType;
  isDisabled?: boolean;
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  type: 'button',
  ariaLabel: '',
});
</script>

<template>
  <button
    :type="type"
    :disabled="isDisabled"
    :aria-label="ariaLabel"
    class="transition-all duration-300 shadow-primaryButton focus:shadow-primaryButtonFocus"
    :class="{
      'bg-gradient-to-r from-blue-400 via-green-200 to-blue-400 bg-[length:300%_100%] bg-[position:left] hover:bg-[position:right]': !isDisabled,
    }"
  >
    <slot />
  </button>
</template>
